import React from 'react';

/**
 * Simple bullet list (no per-item heading).
 */
export default function PointersWithoutHeading({ items, className = '' }) {
  if (!items || !Array.isArray(items)) return null;

  const list = items.map((item) => (typeof item === 'string' ? item : (item.text || item)));

  return (
    <ul
      className={`quotation-section quotation-no-break ${className}`}
      style={{
        margin: '0 0 16px 0',
        paddingLeft: 20,
        fontSize: 13,
        color: '#333',
        lineHeight: 1.6,
      }}
    >
      {list.map((text, i) => (
        <li key={i} style={{ marginBottom: 6 }}>{text}</li>
      ))}
    </ul>
  );
}
